import type { BossId } from "./expeditions";

export interface BossState {
  id: BossId;
  phase: 1 | 2 | 3;
  moveIndex: number;
  weakness: string;
}
export const BOSSES = {
  "thorn-warden": {
    name: "荆冠守望者",
    health: 800,
    damage: 20,
    speed: 60,
    color: "#c6eac1",
  },
  "ember-tortoise": {
    name: "赤晶玄甲",
    health: 1100,
    damage: 25,
    speed: 48,
    color: "#ffc38b",
  },
} as const;

/** 阶段与序列是确定性的；不靠随机瞬发攻击制造难度。 */
export function bossPhase(ratio: number): 1 | 2 | 3 {
  return ratio > 0.7 ? 1 : ratio > 0.35 ? 2 : 3;
}
export type BossMove = "lunge" | "roots" | "ring" | "breath";
export function bossMove(state: BossState): BossMove {
  const moves: BossMove[] =
    state.id === "thorn-warden"
      ? state.phase === 1
        ? ["lunge", "roots"]
        : ["lunge", "roots", "ring"]
      : state.phase === 1
        ? ["lunge", "ring"]
        : ["ring", "breath", "lunge"];
  return moves[state.moveIndex % moves.length];
}
